import React from "react"
import Icon from "./Icon"
import Close from "./close.svg"

const CloseIcon = props => <Icon src={Close} square {...props} />

export default CloseIcon
